import { supabase } from '../lib/supabase';

const BUCKET = 'featured-images';
const LOGO_FOLDER = 'branding';

const logoService = {
  // Fetch current logo settings (no auth required)
  async getLogoSettings() {
    try {
      const { data, error } = await supabase?.from('logo_settings')?.select('*')?.order('updated_at', { ascending: false })?.limit(1)?.single();

      if (error && error?.code !== 'PGRST116') throw error;
      return { data: data || null, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Upload logo icon image
  async uploadLogoIcon(file) {
    try {
      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${LOGO_FOLDER}/logo-icon-${Date.now()}.${fileExt}`;

      const { error: uploadError } = await supabase?.storage?.from(BUCKET)?.upload(fileName, file, { upsert: true });

      if (uploadError) throw uploadError;

      const { data: { publicUrl } } = supabase?.storage?.from(BUCKET)?.getPublicUrl(fileName);

      return { data: { url: publicUrl, path: fileName }, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Upload logo text image
  async uploadLogoText(file) {
    try {
      const fileExt = file?.name?.split('.')?.pop();
      const fileName = `${LOGO_FOLDER}/logo-text-${Date.now()}.${fileExt}`;

      const { error: uploadError } = await supabase?.storage?.from(BUCKET)?.upload(fileName, file, { upsert: true });

      if (uploadError) throw uploadError;

      const { data: { publicUrl } } = supabase?.storage?.from(BUCKET)?.getPublicUrl(fileName);

      return { data: { url: publicUrl, path: fileName }, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Save logo settings to database (upsert the single row)
  async saveLogoSettings({ logoIconUrl, logoIconPath, logoTextUrl, logoTextPath, updatedBy }) {
    try {
      // Get existing row id
      const { data: existing } = await supabase?.from('logo_settings')?.select('id')?.limit(1)?.single();

      const payload = {
        updated_at: new Date()?.toISOString(),
        updated_by: updatedBy || null,
      };

      if (logoIconUrl !== undefined) {
        payload.logo_icon_url = logoIconUrl;
        payload.logo_icon_path = logoIconPath || null;
      }
      if (logoTextUrl !== undefined) {
        payload.logo_text_url = logoTextUrl;
        payload.logo_text_path = logoTextPath || null;
      }

      let result;
      if (existing?.id) {
        result = await supabase?.from('logo_settings')?.update(payload)?.eq('id', existing?.id)?.select()?.single();
      } else {
        result = await supabase?.from('logo_settings')?.insert(payload)?.select()?.single();
      }

      if (result?.error) throw result?.error;
      return { data: result?.data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Delete old file from storage
  async deleteLogoFile(path) {
    try {
      if (!path) return { error: null };
      const { error } = await supabase?.storage?.from(BUCKET)?.remove([path]);
      if (error) throw error;
      return { error: null };
    } catch (error) {
      return { error };
    }
  },
};

export default logoService;
